import React from 'react';
import PropTypes from 'prop-types';
import OptionMessage from '../ui/OptionMessage';
import {Message} from '@aperza/ui';

export default class SearchResultHeader extends React.Component {

  constructor(props) {
    super(props);
    // console.log('SearchResultHeader-constructor:',this.props);
  }

  static propTypes = {
    pageMetadata: PropTypes.object.isRequired
  };

  changeLimitForRecords = e => {
    // console.log(`selected option is: ${e.target.value}`);
    this.props.updateLimit(e.target.value);
  }

  render() {
    let pageMetadata = this.props.pageMetadata;
    // console.log("SearchResultHeader-render", this.props.pageMetadata.totalRecords);

    return (
      <div className="rt-top">
        <span className="headerCount">
          <Message messageId={"searchResultHeader.label"}
                   values={{total: pageMetadata.totalRecords, from: pageMetadata.recordsFrom, to: pageMetadata.recordsTo}} />
        </span>
        <span className="headerPageSizeDd">
          <select onChange={this.changeLimitForRecords}>
            <OptionMessage optionValue={10} messageId={"searchResultHeader.limit"} values={{limit: 10}} />
            <OptionMessage optionValue={20} messageId={"searchResultHeader.limit"} values={{limit: 20}} />
            <OptionMessage optionValue={30} messageId={"searchResultHeader.limit"} values={{limit: 30}} />
          </select>
        </span>
      </div>
    )
  }
}
